import React from 'react';
import classNames from 'classnames';
import { Route, Switch } from 'react-router';
import { Map } from 'immutable';
import { LastLocationProvider } from 'react-router-last-location';
import { useSelector } from 'react-redux';
import config from 'react-global-configuration';

import {
  I18nProvider,
  EntityMapperContext,
} from '@uncinc/react-drupal-core';

import { IS_CLIENT, OF_DOMAIN, MAATJES_DOMAIN } from '../../config/constants';
import CustomRoute from '../CustomRoute';

import {
  Cookie,
  ParallaxProvider,
  PopupAnnouncement,
} from '../../components';

import {
  Navigation,
  Footer,
} from '../../implementations';

import i18next from '../../config/i18next';

import blocksMapper from '../../mappers/blocks';
import nodeMapper from '../../mappers/node';
import paragraphMapper from '../../mappers/paragraphs';
import taxonomyMapper from '../../mappers/taxonomy';
import viewsMapper from '../../mappers/views';

import Entity from '../Entity';
import ProjectMap from '../ProjectMap';
import SearchV2 from '../Search/SearchV2';
import SearchMaatjes from '../Search/SearchMaatjes';
import CampaignStreet from '../CampaignStreet';

import './style.scss';

export const entityTypeMapper = {
  block: blocksMapper,
  node: nodeMapper,
  paragraph: paragraphMapper,
  taxonomy: taxonomyMapper,
  view: viewsMapper,
};

const App = () => {
  const domain = config.get('CURRENT_DOMAIN');

  const path = useSelector((state) => state.getIn(['router', 'location', 'pathname']));
  const entityId = useSelector((state) => state.getIn(['entity', 'entityId'], null));
  const entityType = useSelector((state) => state.getIn(['entity', 'entityType'], null));
  const childEntity = useSelector((state) => state.getIn([entityType, entityId], Map()));
  const childEntityType = useSelector((state) => state.getIn([entityType, entityId, 'type', 0, 'target_id'], null));
  const entityExists = useSelector((state) => state.getIn(['entity', 'exists']));
  const rootClasses = useSelector((state) => state.getIn(['ui', 'rootClasses']));
  const language = useSelector((state) => state.getIn(['ui', 'language']));

  const VARIANT_CAMPAIGN = 'campaign';
  const VARIANT_PRIVACY = 'privacy';
  const VARIANT_KP = 'kp';

  let variant;
  const campaign = childEntity.getIn(['field_campaign']);

  if (campaign && campaign.size > 0) {
    variant = VARIANT_CAMPAIGN;
  } else if (childEntity.getIn(['nid', 0, 'value']) === 31292) {
    variant = VARIANT_PRIVACY;
  } else if (domain === 'kp') {
    variant = VARIANT_KP;
  }

  const classes = classNames('App', rootClasses.join(' '), `theme--${domain}`, {
    'is-front-page': childEntity.get('is_front'),
    'is-campaign-page': campaign && campaign.size > 0,
    'not-found': !entityExists,
  });

  return (
    <ParallaxProvider>
      <LastLocationProvider>
        <EntityMapperContext.Provider value={entityTypeMapper}>
          <I18nProvider locale={language} i18next={i18next}>
            <div className={classes} language={language}>
              <header>
                <Navigation variant={variant} campaignEntity={campaign} entityType={childEntityType} />
              </header>
              <main className="main">
                <Switch>
                  <CustomRoute exact path="/zoeken" render={() => {
                    return domain === MAATJES_DOMAIN ? <SearchMaatjes /> : <SearchV2 />;
                  }} />
                  {domain === OF_DOMAIN && (
                    <CustomRoute exact path="/landkaart" render={() => (<ProjectMap />)} />
                  )}
                  {domain === OF_DOMAIN && (
                    <CustomRoute exact path="/20-jaar-ertoe-doen/straat" render={() => (<CampaignStreet />)} />
                  )}
                  <Route render={() => (<Entity />)} />
                </Switch>
              </main>
              {!['/landkaart', '/campagne/straat'].includes(path) && (
                <Footer variant={variant} campaignEntity={campaign} />
              )}
              <div id="modal-root" />
              {IS_CLIENT && (
                <Cookie />
              )}
              <PopupAnnouncement />
            </div>
          </I18nProvider>
        </EntityMapperContext.Provider>
      </LastLocationProvider>
    </ParallaxProvider>
  );
}

export default App;
